import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {
  useSelector
} from 'react-redux';
import TranslateText from '../translateText/translateText';

function Text({
  type,
  inyectClass,
  children,
  translateText,
  stringBefore,
  stringAfter
}) {
  const userAgent = useSelector((state) => state.userAgent.value);
  const getTheme = userAgent.theme;

  return (
    <span
      className={`body-${type} ${getTheme} ${inyectClass || ''}`}
    >
      {stringBefore && `${stringBefore} `}
      {children ?? <TranslateText text={translateText} />}
      {stringAfter && ` ${stringAfter}`}
    </span>
  )
}

Text.propTypes = {
  type: PropTypes.string.isRequired,
  inyectClass: PropTypes.string,
  children: PropTypes.node,
  string: PropTypes.string,
  stringBefore: PropTypes.string,
  stringAfter: PropTypes.string,
};

export default Text;
